module.exports = __webpack_public_path__ + "img/ATCion_card_image.82aa366a.jpg";